import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/Header';
import About from './pages/About';
import Home from './pages/Home';
import Footer from "./components/Footer";
import Contact from './pages/Contact';
import Services from './pages/Services';
import WhatsAppButton from "./components/WhatsAppButton";
import Documents from "./pages/Documents";
import Pricing from "./pages/Pricing";
import Seo from "./components/Seo";

function App() {
  const [openLinks, setOpenLinks] = useState(false);

  return (
    <Router>
      <div className="App">
        <Header />
        <Seo />
        <Routes>
          <Route path="/" element={<Home setOpenLinks={setOpenLinks} />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/hizmetlerimiz" element={<Services />} />
          <Route path="/fiyatlar" element={<Pricing />} />
          <Route path="/documents" element={<Documents />} />
        </Routes>
        <WhatsAppButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
